import { render, staticRenderFns } from "./IntegrationsVacancyItem.vue?vue&type=template&id=afba35bc&scoped=true&"
import script from "./IntegrationsVacancyItem.vue?vue&type=script&lang=js&"
export * from "./IntegrationsVacancyItem.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsVacancyItem.vue?vue&type=style&index=0&id=afba35bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afba35bc",
  null
  
)

/* custom blocks */
import block0 from "./IntegrationsVacancyItem.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./IntegrationsVacancyItem.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=ru"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
